import { searchDiagnosticsStore } from 'owa-search-diagnostics';
import {
    TypeValues,
    UserVoiceFeedbackSearchTags,
    Team1,
} from 'owa-uservoice/lib/services/UserVoiceFeedbackTags';
import { escape } from 'global';
import { UserVoiceSearchTeam } from '../components/SearchInContextFeedbackDialog';

export default function getSearchFeedbackCustomTags(
    userVoiceFeedbackTeam: UserVoiceSearchTeam
): UserVoiceFeedbackSearchTags {
    // deep clone the instrumentation list so that original list is not impacted
    const searchInstrumentationEntries = searchDiagnosticsStore.searchInstrumentationList.map(
        a => ({ ...a })
    );

    // Strip out PII data
    searchInstrumentationEntries.forEach(instrumentation => {
        delete instrumentation.PIIData;
    });

    let userVoiceFeedbackLocationName = null;
    let userVoiceTeam1 = null;

    switch (userVoiceFeedbackTeam) {
        case UserVoiceSearchTeam.MailSearch:
            userVoiceTeam1 = Team1.Search;
            userVoiceFeedbackLocationName = 'Owa mail React';
            break;
        case UserVoiceSearchTeam.CalendarSearch:
            userVoiceTeam1 = Team1.CalendarSearch;
            userVoiceFeedbackLocationName = 'Owa calendar React';
            break;
    }

    const customTags: UserVoiceFeedbackSearchTags = {
        Type: TypeValues.Negative,
        ['Team 1']: userVoiceTeam1,
        FeedbackLocationName: userVoiceFeedbackLocationName,
        SearchHistory: escape(JSON.stringify(searchInstrumentationEntries)),
    };

    return customTags;
}
